import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import {PlanningViewSettingsJobsModel} from "../../../models/planning-view-settings.model";
import * as _ from "lodash";
import {JobsGroupByEnum} from "../../../types/jobs-group-by.enum";
import {AddressRequestType} from "../../../../addresses/angular/types/address-request.type";
import {LocationType} from "../../../../commons/types/location.type";

enum SplitSuggestionType {
  SPLIT_PACKAGES = 'SPLIT_PACKAGES',
  SPLIT_LOCATION = 'SPLIT_LOCATION'
}

require('./planning-draft-jobs-panel-list-item.scss');
@Component({
  standalone: false,
  selector: 'app-planning-draft-jobs-panel-list-item',
  templateUrl: './planning-draft-jobs-panel-list-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftJobsPanelListItemComponent implements OnInit, OnChanges {

  @Input() draft?: any;
  @Input() job: any;
  @Input() route?: any;
  @Input() routes?: any[];
  @Input() highlightedActivity?: any;
  @Input() isSelected: boolean;
  @Input() settings: PlanningViewSettingsJobsModel;
  @Input() itemElementSize: string;
  @Input() isHideSelect: boolean;
  @Input() isChild: boolean = false;
  @Input() isGroupExpanded: boolean;
  @Output() onViewJob = new EventEmitter<{ jobs?: any[], jobIds?: string[], event?: any }>();
  @Output() onToggle = new EventEmitter<{ isSelected: boolean, jobIds: string[] }>();
  @Output() onToggleObligateTimeWindow = new EventEmitter<{ jobIds: string[], obligateTimeWindow: boolean }>();
  @Output() onContextMenu = new EventEmitter<{ job: any, event: MouseEvent }>();
  @Output() onReverseJobSplit = new EventEmitter<{ event: MouseEvent, job: any }>();
  @Output() onGroupExpanded = new EventEmitter<{ id: string, expanded: boolean }>();

  public isHover: boolean;
  public indexesInRoute: { index: number, isHighlighted: boolean }[];
  public routeColor: string;
  public labels: string[];
  public jobsGroupByTypes: typeof JobsGroupByEnum = JobsGroupByEnum;
  public query: any;
  public type: AddressRequestType;
  public isShowAddressIcon: Object = {};
  public isObligatedTimeWindow: boolean = false;
  public isShowObligateTimeWindowToggle: boolean = false;
  public isHighlightObligateTimeWindowToggle: boolean = false;
  public isAccountHover: boolean;
  public SplitSuggestionType = SplitSuggestionType;
  public isRunning: boolean = false;
  public routeMap: { [key: string]: any } = {};

  constructor(
    @Inject('$timeout') private $timeout,
    @Inject('planningCommonService') private planningCommonService) {
  }

  ngOnInit() {
    this._setLabels();
    this.query = {
      draftId: this.draft?.id,
      projectId: this.draft?.projectId
    }
    this.type = AddressRequestType.Planning;

    this._setRouteMap();
    this._setObligateTimeWindow();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.job) {
      this._setLabels();
      this._setRouteIndexes();
      this._setObligateTimeWindow();
      this._setRouteMap();
    }
    if (changes.route || changes.highlightedActivity) {
      this._setRouteIndexes();
      this._setIsRouteProcessRunning();
      this.routeColor = this.route ?
        this.planningCommonService.getRouteColor(this.route) :
        undefined;
    }

    if (changes.routes) {
      this._setRouteMap();
    }
  }

  onClick(event: MouseEvent) {
    if (event.ctrlKey) {
      this.onToggleEvent(event);
      this.$timeout(0).then(() => {
      });
    }
  }


  onToggleEvent($event) {
    this.onToggle.emit({
      isSelected: !this.isSelected,
      jobIds: !!this.job.groupedByType ? this.job.jobIds : [this.job.id]
    })
  }

  onHover(isHover) {
    this.isHover = isHover;
    this.$timeout(0).then(() => {
    });
  }

  onToggleIsShowAddressIcon(key: string, isShow: boolean) {
    this.isShowAddressIcon[key] = isShow;
    this.$timeout(0).then(() => {
    });
  }

  isHighQualityAddress(address: any): boolean {
    return !!(address && address.addressResolvingInfo &&
      address.addressResolvingInfo.qualityGroup === "High");
  }

  isValidAddressType(address: any): boolean {
    return !!(address && (address.locationType === LocationType.ACCOUNT ||
      address.locationType === LocationType.DEPOT ||
      address.locationType === LocationType.RESOURCE ||
      address.locationType === LocationType.CUSTOMER));
  }

  openContextMenu(event: MouseEvent) {
    event.preventDefault();
    if(this.job) {
      this.onContextMenu.emit({ job: this.job, event });
    }
  }

  reverseJobSplit(event: MouseEvent) {
    this.onReverseJobSplit.emit({event, job: this.job})
  }

  toggleExpand(): void {
    this.isGroupExpanded = !this.isGroupExpanded;
    this.onGroupExpanded.emit({id: this.job.id, expanded: this.isGroupExpanded});
  }

  trackByJobId(_:number, job: any): string | number {
    return job.id;
  }

  private _setLabels() {
    this.labels = _.uniq(_.compact(_.flatMap(this.job.packages, 'labels')));
  }

  private _setRouteIndexes() {
    this.indexesInRoute = [];

    if (this.route?.activities.length) {
      this.route.activities.forEach((a, i) => {
        const jobIds = a.jobIds || (a.jobId ? [a.jobId] : [])
        if (_.includes(jobIds, this.job.id)) {
          this.indexesInRoute.push({
            index: (a.indexInRoute || i),
            isHighlighted: a.id === this.highlightedActivity?.id
          });
        }
      })
    }

  }

  private _setIsRouteProcessRunning() {
    this.isRunning = this.route?.actionProcess?.running && (new Date().getTime() < this.route?.actionProcess?.expirationDate);
  }

  private _setObligateTimeWindow() {
    this.isObligatedTimeWindow = false;
    if (!this.job.stops?.length) {
      return;
    }
    for (let i = 0; i < this.job.stops.length; i++) {
      if (this.job.stops[i].obligateTimeWindow) {
        this.isObligatedTimeWindow = true;
        break;
      }
    }
  }

  private _setRouteMap(): void {
    if (!this.isChild && this.routes) {
      this.job.jobs?.forEach(job => {
        const x = this.routes?.find(route => route.id === job.routeId);
        if (x) {
          this.routeMap[job.id] = x;
        }
      });
    }
  }
}

